import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	default: {
		id: 'servicedesk-help-center-select-field.common.help-center-option-custom-label.default',
		defaultMessage: 'Default',
		description: 'Default lozenge to identify the default help center',
	},
});
